/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import { BaseStepCompProps } from './types';


interface ReferralInfoProps extends Omit<BaseStepCompProps, 'handleNext'>{
  handleNext: () => void;
}

const ReferralInfo = (props: ReferralInfoProps) => {
  const { updateForm, handlePrevious, handleNext, formData } = props;

  return <>
    <div className='d-lg-flex justify-content-between onboarding-form'>
      <aside className='title-container'>
        <div className='h1 mb-3'>Referral info</div>
      </aside>
      <section className='form-container'>
        <Form className='my-5' >
        <div className='row mb-4'>
            <div className='col'>
              <FormGroup>
                <Label for='referenceCompany'>Who introduced you to this service?</Label>
                <Input
                  id='referenceCompany'
                  name='referenceCompany'
                  type='text'
                  placeholder={'Referring company name'}
                  onChange={(e) => updateForm('referenceCompany', e.target.value)}
                  defaultValue={formData.referenceCompany}
                />
                <p className='mt-1'>Optional</p>
              </FormGroup>
            </div>
          </div>
          <div className='row mb-4'>
            <div className='col'>
              <FormGroup>
                <Label for='referralCode'>Enter your referral code</Label>
                <Input
                  placeholder='Referral code'
                  id='referralCode'
                  name='referralCode'
                  type='text'
                  onChange={(e) => updateForm('referralCode', e.target.value)}
                  defaultValue={formData.referralCode}
                />
                <p className='mt-1'>If you were given one</p>
              </FormGroup>
            </div>
          </div>
        </Form>
        <div className='mt-3 d-flex'>
          <Button outline className='mr-auto' onClick={handlePrevious}><i className='far fa-angle-left mr-2' />Back</Button>
          <Button className='ml-1' color='primary' onClick={handleNext}>Next<i className='far fa-angle-right ml-2' /></Button>
        </div>
      </section>
    </div>
  </>
}

export default ReferralInfo;
